import st from "@/styles/Ui.module.scss";
import WritePinFields from "@/ui/WritePinFields.tsx";
import Button from "@/ui/Button.tsx";
import LoginLoader from "@/ui/LoginLoader.tsx";
import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {useAtom} from "jotai/index";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import {useTranslation} from "react-i18next";
import useAuth from "@/hooks/auth.ts";
import {profile} from "@/atoms/profile.ts";
import useIntervals from "@/hooks/intervals.ts";
import {TextField} from "@mui/material";
import {textfield_sx} from "@/utils/mui_sx.ts";
import ResendCounter from "@/ui/ResendCounter.tsx";
import {edit_email_otp_interval, pin_value} from "@/atoms/common.ts";
import Countdown, {CountdownRenderProps} from "react-countdown";
import ArrowCircledIcon from "@/svg/ArrowCircledIcon.tsx";


const SetEmailModal = () => {
    const [open, setOpen] = useState(false)
    const effect_ran = useRef<boolean>(false)
    const [loading, set_loading] = useState<boolean>(false)
    const [otp_error, set_otp_error] = useState<boolean>(false)
    const [error, set_error] = useState<boolean>(false)
    const [email, set_email] = useState<string>("")
    const [step, set_step] = useState(1)
    const form_ref = useRef<any>(null)
    const [otp_fields] = useAtom(pin_value);
    const auth = useAuth()
    const [user] = useAtom(profile)
    const intervals_hook = useIntervals(edit_email_otp_interval)
    const [interval, set_interval] = useAtom(edit_email_otp_interval)
    const is_interval = Boolean(interval !==  null && interval.length)
    
    const {t} = useTranslation()
    
    const openModal = (x:boolean) => {
        setOpen(x)
    }
    
    const set_loading_handler = useCallback((x: boolean) => {
        set_loading(x);
    }, [set_loading]);
    
    const set_otp_err_handler = useCallback((x: boolean) => {
        set_otp_error(x);
    }, [set_otp_error]);
    
    const set_pwd_err_handler = useCallback((x: boolean) => {
        set_error(x);
    }, [set_error]);
    
    
    const resetHandlerStepTwo = async (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault()
        
        let otp = otp_fields.join("")
        
        const res = await auth.resetEmailSt2(
            email,
            otp,
        )

        if(res){
            set_step(1)
            eventEmitter.emit(CommonClass.CustomEvents.reset_otp_value)
            setOpen(false)
        }
    }
    
    const resetHandlerStepOne = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        
        if(!user) return
        
        const form = new FormData(e.currentTarget)
        
        if (typeof form.get("email") === "string") {
            const email_to_send = form.get("email") as string;
            set_step(1)
            await sendOTP(email_to_send)
        }
    }
    
    const sendOTP = async (email_to_send?:string) => {
        const enabled = await auth.resetEmailSt1(email_to_send || email);

        if(enabled) {
            set_step(2)
            set_otp_error(false)
            eventEmitter.emit(CommonClass.CustomEvents.set_resend_interval, false)
            intervals_hook.setIntervalHandler()
        }
    }
    
    useEffect(() => {

        if(otp_fields.length === 4) {
            let completed = true
            
            otp_fields.map((x) => {
                if(x === "" || x === " ") {
                    completed = false
                }
                
            })
            
            if(completed && form_ref.current) {
                form_ref.current.requestSubmit()
            }
        }
        
    }, [otp_fields]);
    
    useEffect(() => {
        if(!effect_ran.current) {
            eventEmitter.on(CommonClass.ModalEvents.SetEmail, openModal)
            eventEmitter.on(CommonClass.CustomEvents.set_edit_profile_load, set_loading_handler)
            eventEmitter.on(CommonClass.CustomEvents.set_err_otp, set_otp_err_handler)
            eventEmitter.on(CommonClass.CustomEvents.set_err_pwd, set_pwd_err_handler)
        }
        
        if(is_interval) {
            set_step(2)
        }
        
        return () => {
            effect_ran.current = true
            
            if(!effect_ran.current) {
                eventEmitter.off(CommonClass.CustomEvents.set_edit_profile_load, set_loading_handler)
                eventEmitter.off(CommonClass.CustomEvents.set_err_otp, set_otp_err_handler)
                eventEmitter.off(CommonClass.CustomEvents.set_err_pwd, set_pwd_err_handler)
                eventEmitter.off(CommonClass.ModalEvents.SetEmail, openModal)
            }
        }
    }, []);
    
    return (
        <ModalLayout
            className={st.edit_profile_modal}
            open={open}
            innerClassName={st.edit_profile_modal_inner}
            on_close_state={() => {
                setOpen(false)
            }}
            onAfterOpen={() => {
                if(is_interval && email.length > 1) {
                    set_step(2)
                }
            }}
        >
            <>
                <div className={st.heading}>
                    
                    {step === 2 && (
                        <button
                            onClick={() => {
                                set_step(1)
                            }}
                        >
                            <ArrowCircledIcon />
                        </button>
                    )}
                    
                    
                    <h4>{user?.email.length ? t("modify_email") : t("set_email")}</h4>
                </div>
                
                {step === 1 && (
                    <div className={st.content}>
                        
                        {/*<p className={st.info}>*/}
                        {/*    {t("valid_email_err")}*/}
                        {/*</p>*/}
                        
                        <form onSubmit={resetHandlerStepOne} autoComplete={'off'}>

                            
                            <TextField
                                onChange={(e) => {
                                    set_email(e.target.value)
                                }}
                                defaultValue={email}
                                label="Email"
                                name={"email"}
                                type={"email"}
                                error={error}
                                sx={textfield_sx}
                                color="success"
                                placeholder={"email.address@email.com"}
                                // onFocus={() => {
                                //     eventEmitter.emit(CommonClass.ModalEvents.FocusInputs, true)
                                // }}
                                // onBlur={() => {
                                //     eventEmitter.emit(CommonClass.ModalEvents.FocusInputs, false)
                                // }}
                            />
                            
                            <Button
                                disabled={is_interval}
                                type={"submit"}
                            >
                                {t("send_code")}
                            </Button>
                            
                            {interval !==  null && interval.length ? (
                                <div className={st.countdown}>
                                    {t("resend_in")}
                                    
                                    <Countdown
                                        date={JSON.parse(interval).interval}
                                        renderer={(args) => renderer({...args})}
                                        intervalDelay={1000}
                                        zeroPadTime={2}
                                        onComplete={() => {
                                            set_interval("")
                                        }}
                                    />
                                </div>
                            ) : null}
                        
                        </form>

                        {loading && <LoginLoader/>}
                    
                    </div>
                )}
                
                {step === 2 && (
                    <div className={st.content} >
                        <p className={st.info}>
                             {t("email_code_info_text1")}
                        </p>
                        
                        <form
                            ref={form_ref}
                            autoComplete={'off'}
                            onSubmit={resetHandlerStepTwo}
                        >
                            <WritePinFields
                                error={otp_error}
                                className={st.pin}
                            />
                            
                            {/*<div className={st.controller_row}>*/}
                            {/*    */}
                            {/*    <Button*/}
                            {/*        outlined*/}
                            {/*        type={"button"}*/}
                            {/*        className={st.back}*/}
                            {/*        onClick={() => {*/}
                            {/*            set_step(1)*/}
                            {/*        }}*/}
                            {/*        disabled={is_interval}*/}
                            {/*    >*/}
                            {/*        <ChevroneIcon />*/}
                            {/*        {t("back")}*/}
                            {/*    </Button>*/}
                            {/*    */}
                            {/*    <Button  className={st.submit} type={"submit"}>*/}
                            {/*        {t("confirm_email")}*/}
                            {/*    </Button>*/}
                            {/*</div>*/}
                            
                        </form>
                        
                        <ResendCounter
                            onClick={() => {
                                sendOTP(email)
                            }}
                            interval_atom={edit_email_otp_interval}
                        />
                        
                        {loading && <LoginLoader/>}
                    
                    </div>
                )}
            
            </>
        
        </ModalLayout>
    )
}

const renderer = (args: CountdownRenderProps) => {
    const {minutes, seconds} = args;
    const padValue = (value: number) => (value < 10 ? `0${value}` : `${value}`);
    
    return (
        <div>
            {padValue(minutes) || "00"} :
            {" " + padValue(seconds) || " 00"}
        </div>
    );
    
};

export default SetEmailModal